import { RiskSeverity } from '@/types';

// Styling configuration for risk severity cards used across multiple components
export const riskSeverityCardClass: Record<
  RiskSeverity,
  { bg: string; border: string; dotClassName: string; lineClassName: string }
> = {
  [RiskSeverity.Critical]: {
    bg: 'bg-chariot-status-critical',
    border: 'border-chariot-stroke-critical',
    dotClassName: 'stroke-chariot-stroke-critical',
    lineClassName:
      '[&>path]:stroke-chariot-stroke-critical text-chariot-stroke-critical fill-chariot-stroke-critical',
  },
  [RiskSeverity.High]: {
    bg: 'bg-chariot-status-high',
    border: 'border-chariot-stroke-high',
    dotClassName: 'stroke-chariot-stroke-high',
    lineClassName:
      '[&>path]:stroke-chariot-stroke-high text-chariot-stroke-high fill-chariot-stroke-high',
  },
  [RiskSeverity.Medium]: {
    bg: 'bg-chariot-status-medium-strong',
    border: 'border-chariot-stroke-medium',
    dotClassName: 'stroke-chariot-stroke-medium',
    lineClassName:
      '[&>path]:stroke-chariot-stroke-medium text-chariot-stroke-medium fill-chariot-stroke-medium',
  },
  [RiskSeverity.Low]: {
    bg: 'bg-chariot-status-low',
    border: 'border-chariot-stroke-low',
    dotClassName: 'stroke-chariot-stroke-low',
    lineClassName:
      '[&>path]:stroke-chariot-stroke-low text-chariot-stroke-low fill-chariot-stroke-low',
  },
  [RiskSeverity.Info]: {
    bg: 'bg-chariot-status-info',
    border: 'border-chariot-stroke-info',
    dotClassName: 'stroke-chariot-stroke-info',
    lineClassName:
      '[&>path]:stroke-chariot-stroke-info text-chariot-stroke-info fill-chariot-stroke-info',
  },
  [RiskSeverity.Exposure]: {
    bg: '',
    border: '',
    dotClassName: '',
    lineClassName: '',
  },
};
